// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__1jrSP","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__2Su8T"};